import type { SxProps, Theme } from "@mui/material";
import type { DateTime } from "luxon";
import type { ReactNode } from "react";
import { useEffect } from "react";
import { CommonDashboardBox } from "../../../components/Dashboard/CommonDashboardBox";
import { CommonDashboardHeader } from "../../../components/Dashboard/CommonDashboardHeader";
import InHouseBarChart from "../../../components/UIToolkit/Graphs/BarChart/InHouseBarChart";
import { useAnalytics } from "../../../contexts/analytics/hooks";
import { useHospitalData } from "../../../contexts/HospitalDataProvider";
import { useGetManagementCenterCallIns } from "../hooks";
import { buildClampRange, fetchedDataToBarDataGroups } from "../utils";

export const CallIns = ({
	dateFrom,
	dateTo,
	roles,
	jobs,
	shiftHours,
	excludeHolidays,
	trailing,
	containerSx,
	shrinkLegendForSmallScreens,
	departmentId,
}: {
	dateFrom: DateTime;
	dateTo?: DateTime;
	roles?: string[];
	jobs?: string[];
	shiftHours?: string[];
	excludeHolidays?: boolean;
	trailing?: ReactNode;
	containerSx?: SxProps<Theme>;
	shrinkLegendForSmallScreens?: boolean;
	departmentId?: string;
}) => {
	const { trackError } = useAnalytics();
	const { timezone } = useHospitalData();
	const { data, isError, isLoading, error } = useGetManagementCenterCallIns({
		sinceDate: dateFrom,
		endDate: dateTo,
		roles,
		jobs,
		shiftHours,
		excludeHolidays,
		departmentId,
	});

	useEffect(() => {
		if (isError) {
			trackError("fetch_management_center_call_ins_error", {
				error_message: error?.message,
			});
		}
	}, [isError, error, trackError]);

	const transformedData =
		!isLoading && data ? fetchedDataToBarDataGroups({ data, timezone, clampRange: buildClampRange(dateFrom, dateTo, timezone) }) : undefined;

	return (
		<CommonDashboardBox sx={{ display: "flex", flexDirection: "column", alignItems: "start", gap: 1, width: "calc(33% - 4px)", ...containerSx }}>
			<CommonDashboardHeader label={"Shift Removals"} trailing={trailing} />
			<InHouseBarChart
				shrinkLegendForSmallScreens={shrinkLegendForSmallScreens}
				stackedGroups={transformedData}
				width={"100%"}
				height={containerSx ? "100%" : undefined}
			/>
		</CommonDashboardBox>
	);
};
